import React, { useState, useEffect } from "react";
import { IconButton, Tooltip } from "@mui/material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { db, doc, updateDoc } from "../firebaseConfig";
import { functions, httpsCallable } from "../firebaseConfig";
import EmailModalV2 from "./EmailModalV2";
import DateSelectorDialog from "../GlobalComponents/DateSelectorDialog";
import { parseDate } from "./emailUtils";

const ConfirmedEmailV2 = ({ open, onClose, confirmationEmailData, theme }) => {
  const [selectedJobs, setSelectedJobs] = useState([]);
  const [dateDialogOpen, setDateDialogOpen] = useState(false);
  const [emailTemplate, setEmailTemplate] = useState("");

  const sendEmail = httpsCallable(functions, "sendEmail");

  // Generate the confirmed email HTML template
  const generateEmailTemplate = () => {
    if (!confirmationEmailData?.jobData || !confirmationEmailData?.clientData) {
      return "";
    }

    const mainJobDate = parseDate(confirmationEmailData.jobData);
    const additionalJobsHtml = selectedJobs
      .map(
        (job) =>
          `<p style="line-height: 23px; margin: 16px 0;"><strong><span style="color: rgb(255, 0, 0);">${job.label}</span></strong></p>`
      )
      .join("");

    const isLifeOrVideo =
      confirmationEmailData.jobData.jobTypeFull.includes("-L") ||
      confirmationEmailData.jobData.jobTypeFull.includes("-V");

    return `
      <div style="max-width: 700px; margin: 0 auto; background-color: rgb(255, 255, 255); padding: 2.5rem; border-radius: 0.75rem; box-shadow: 0 4px 6px -1px rgb(0, 0, 0, 0.1), 0 2px 4px -2px rgb(0, 0, 0, 0.1); text-align: center; margin-top: 2.5rem; margin-bottom: 2.5rem;">
        <div style="background-color: rgb(255, 255, 255); border: 1px solid #eaeaea; border-radius: 0.5rem; padding: 40px; margin-bottom: 20px;">
          <div style="margin-bottom: 40px; margin-top: -20px;">
            <img alt="ITS LOGO" src="https://www.imagesthatsell.com.au/ITS_LOGO_BLACK%20BLACK.jpg" width="100" style="margin: 0 auto; display: block;" />
          </div>
          
          <div style="text-black text-[14px] font-normal text-center margin-bottom: 20px; margin-top: -20px;">
            <h3 style="font-size: 18px; font-weight: 700; margin-top: 2px; margin-bottom: 2px; color: black;">THANKS FOR CONFIRMING YOUR BOOKING!</h3>
            
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; color: rgb(55, 65, 81);">
              Appropriate shoot and post-production time has been allocated based on the shot count and information provided.
            </p>
            
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; color: rgb(55, 65, 81);">
              Do let us know if the shot count changes prior to your shoot date so we can make the necessary adjustments to your booking.
            </p>
            
            <p style="line-height: 23px; margin: 16px 0;">
              <strong><span style="color: rgb(255, 0, 0);">${mainJobDate}</span></strong>
            </p>
            
            ${additionalJobsHtml}
            
            ${
              isLifeOrVideo
                ? `
            <p style="font-size: 11px; margin: 16px 0;">
              <strong><span style="color: rgb(65, 105, 225);">STREET PARKING AVAILABLE WHEN ARRIVING PRIOR TO 8.30AM. NO ONSITE PARKING.</span></strong>
            </p>
            `
                : ""
            }
            
            <h4 style="font-size: 14px; font-weight: 700; margin-top: 16px; margin-bottom: 8px; text-align: left; color: black;">FILE NAMING</h4>
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; text-align: left; color: black;">
              In order for ITS to provide you with file naming, we require the names to be supplied via the unique ITS Google Sheet Link below:
            </p>
            
            ${
              confirmationEmailData.clientData.spreadsheetURL
                ? `
            <div style="text-align: center; margin: 20px 0;">
              <a href="${confirmationEmailData.clientData.spreadsheetURL}" target="_blank" style="line-height: 100%; text-decoration: none; display: inline-block; max-width: 100%; padding: 12px 20px; background-color: rgb(0, 0, 0); border-radius: 0.25rem; color: rgb(255, 255, 255); font-size: 12px; font-weight: 600; text-align: center;">
                <span style="max-width: 100%; display: inline-block; text-transform: uppercase;">CLICK HERE</span>
              </a>
            </div>
            `
                : ""
            }
            
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; text-align: left; color: black;">
              Please see the first tab of instructions.<br><br>
              Please populate this link with the exact file names you require on your images.<br><br>
              Please include any specific styling notes for our team to follow.
            </p>
            
            <h4 style="font-size: 14px; font-weight: 700; margin-top: 16px; margin-bottom: 8px; text-align: left; color: black;">PRODUCT DELIVERY</h4>
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; text-align: left; color: black;">
              Please deliver your product to the studio prior to 12pm the day before your shoot.<br><br>
              To note: for life shoots with models, majority of clothing prep and steaming occurs on the morning of your shoot in the 1 x hour of set-up time. If you think more time is required we can arrange additional prep fees apply.<br><br>
              All garments must arrive on hangers.<br><br>
              If this is not possible, let us know ahead of time as we will need to allocate extra staff members to unpack and hang your product. This may incur an extra handling fee.<br><br>
              For product-only shoots (i.e. ghost, flat-lay etc), please number each hanger/product with the corresponding shot number on your Google Sheet (i.e. shot 1 = 1). This is imperative for the team to identify the correct garment for each unique style code in a timely manner.<br><br>
              Photos of garments are not necessary if you do this. Please advise us if this is not possible as additional time and fees apply to decipher imagery and product on set.
            </p>
            
            <h4 style="font-size: 14px; font-weight: 700; margin-top: 16px; margin-bottom: 8px; text-align: left; color: black;">FILE DELIVERY</h4>
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; text-align: left; color: black;">
              Your final files are due 5 x business days after the last shoot date or storyboard approval.<br>
              If you require express files this can be arranged, but maybe subject to availability. Express fees apply.<br><br>
              Please advise our team if you require additional outputs such as The Iconic or David Jones, or if there have been any other changes to your image specifications prior to your shoot so that our post-production team can supply your job correctly and on time.
            </p>
            
            <h4 style="font-size: 14px; font-weight: 700; margin-top: 16px; margin-bottom: 8px; text-align: left; color: black;">PRODUCT COLLECTIONS</h4>
            <p style="font-size: 14px; line-height: 24px; margin: 16px 0; text-align: left; color: black;">
              We require to keep your samples on hand for the duration of the file delivery period for colour correction. If this is not possible, we can match colour to fabric swatches (min 10cm x 10cm).<br>
              Please ensure to send these with your pieces if you plan on an early collection. We won't be able to guarantee colour without the physical samples or swatches.<br><br>
              For returns, please email bookings@imagesthatsell.com.au on the day you wish to collect. We will then have an available styling assistant to pack and email you when your pieces are available for your collection. Please note we do not organise any returns and do not accept Ubers or similar.<br><br>
              Thanks again for working with Images That Sell and please do not hesitate to reach out should you have any questions.<br><br>
              If you're a new client, see below our terms and conditions.
            </p>
            
            <div style="display: flex; flex-direction: column; align-items: center; margin-top: 30px; margin-bottom: 20px;">
              <a href="http://www.imagesthatsell.com.au/docs/its-terms-and-conditions.pdf" target="_blank" style="line-height: 100%; text-decoration: none; display: inline-block; max-width: 100%; padding: 12px 20px; background-color: rgb(0, 0, 0); border-radius: 0.25rem; color: rgb(255, 255, 255); font-size: 12px; font-weight: 600; text-align: center;">
                <span style="max-width: 100%; display: inline-block; line-height: 120%; text-transform: uppercase;">TERMS & CONDITIONS</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    `;
  };

  const handleSend = async (emailData) => {
    try {
      const result = await sendEmail({
        emailBody: emailData.htmlContent,
        fromEmail: "bookings@imagesthatsell.com.au",
        toEmails: emailData.to,
        ccEmails: emailData.cc,
        bccEmails: emailData.bcc,
        replyToEmails: emailData.replyTo,
        subject: emailData.subject,
        attachments: emailData.attachments || [],
      });

      if (result.data.error) {
        throw new Error(result.data.errortext);
      } else {
        // Update main job status to 'confirmed' and set confirmationEmailSent flag
        await updateDoc(doc(db, "JobData", confirmationEmailData.jobData.id), {
          confirmationStatus: "confirmed",
          confirmationEmailSent: true,
        });

        // Update all selected jobs status to 'confirmed'
        const updatePromises = selectedJobs.map((job) =>
          updateDoc(doc(db, "JobData", job.id), {
            confirmationStatus: "confirmed",
          })
        );
        await Promise.all(updatePromises);

        onClose();
      }
    } catch (error) {
      console.error("Error sending email:", error);
      throw error;
    }
  };

  // Update email template when selectedJobs changes
  useEffect(() => {
    setEmailTemplate(generateEmailTemplate());
  }, [selectedJobs]);

  // Custom toolbar button for Select Dates functionality
  const selectDatesButton = (
    <Tooltip title="Select Dates">
      <IconButton
        size="medium"
        onClick={() => setDateDialogOpen(true)}
        sx={{
          color: "inherit",
          borderRadius: "50%",
          "&:hover": {
            bgcolor: "rgba(255,255,255,0.1)",
          },
        }}
      >
        <DateRangeIcon fontSize="medium" />
      </IconButton>
    </Tooltip>
  );

  if (!confirmationEmailData?.jobData || !confirmationEmailData?.clientData) {
    return null;
  }

  return (
    <>
      <DateSelectorDialog
        open={dateDialogOpen}
        onClose={() => setDateDialogOpen(false)}
        selectedJobs={selectedJobs}
        setSelectedJobs={setSelectedJobs}
        theme={theme}
        confirmationEmailData={confirmationEmailData}
      />

      <EmailModalV2
        open={open}
        onClose={onClose}
        initialTo={confirmationEmailData.clientData.contacts || []}
        initialCc={[]}
        initialBcc={[]}
        template={emailTemplate || generateEmailTemplate()}
        subject="Booking Confirmed"
        onSend={handleSend}
        customButtons={selectDatesButton}
        fromEmail="bookings@imagesthatsell.com.au"
        jobActions={{
          type: "confirmation",
          mainJobId: confirmationEmailData.jobData.id,
          selectedJobIds: selectedJobs.map((job) => job.id),
          updates: {
            confirmationStatus: "confirmed",
            confirmationEmailSent: true,
          },
        }}
      />
    </>
  );
};

export default ConfirmedEmailV2;
